import { usePlanFeatures } from "@api/hooks/useSubscription";
import { useAuthStore } from "@store/authStore";

export const RECORD_TYPES = [
  {
    id: "invoice",
    label: "Invoices",
    feature: "documents",
    permission: "document.read",
  },
  {
    id: "receipt",
    label: "Receipts",
    feature: "documents",
    permission: "document.read",
  },
  {
    id: "purchase_order",
    label: "Purchase orders",
    feature: "documents",
    permission: "document.read",
  },
  {
    id: "ap_posting",
    label: "AP postings",
    feature: "ap_postings",
    permission: "ap_posting.read",
  },
  { id: "vendor", label: "Vendors", feature: "vendors", permission: null },
] as const;
export type RecordType = (typeof RECORD_TYPES)[number]["id"];

export const RECORD_TABS = [
  {
    id: "documents",
    label: "Documents",
    feature: "documents",
    permission: "document.read",
  },
  {
    id: "ap_posting",
    label: "AP postings",
    feature: "ap_postings",
    permission: "ap_posting.read",
  },
  { id: "vendor", label: "Vendors", feature: "vendors", permission: null },
] as const;
export type RecordTab = (typeof RECORD_TABS)[number]["id"];

export function availableRecordTypes(
  features: Record<string, boolean>,
  hasPermission: (permission: string) => boolean,
) {
  return RECORD_TYPES.filter(
    (t) =>
      (features._all_features === true || features[t.feature] === true) &&
      (!t.permission || hasPermission(t.permission)),
  );
}

export function useRecordTypes() {
  const features = usePlanFeatures();
  const permission = useAuthStore((s) => s.hasPermission);
  return availableRecordTypes(features, permission);
}

export function availableRecordTabs(
  features: Record<string, boolean>,
  hasPermission: (permission: string) => boolean,
) {
  return RECORD_TABS.filter(
    (tab) =>
      (features._all_features === true || features[tab.feature] === true) &&
      (!tab.permission || hasPermission(tab.permission)),
  );
}

export function useRecordTabs() {
  const features = usePlanFeatures();
  const permission = useAuthStore((s) => s.hasPermission);
  return availableRecordTabs(features, permission);
}
